






















































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { Resolve } from 'vue-di';
import { faPrescription, faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { mapKeys } from 'lodash';
import Footer from '~/components/Footer.vue';
import Header from '~/components/Header.vue';
import theme from '~/settings/theme';
import SessionModule from '~/store/session';
import LayoutModule from '~/store/layout';
import IriModule from '~/store/iri';
import styles from '~/assets/style/variables.scss';
import SideBar from '~/components/sideBar.vue';
import ReusableCard from '~/components/ReusableCard.vue';
import Path from '~/store/path';
import LandingPageBtn from '~/components/LandingPageButton.vue';
import GlobalCardArt from '~/components/GlobalCardArt.vue';

@Component<DefaultLayout>({
    components: {
        Footer,
        SideBar,
        Header,
        ReusableCard,
        LandingPageBtn,
        GlobalCardArt
    },
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
    },
    icons: {
        faPrescription,
        faChevronUp,
        faChevronDown,
    },
})
export default class DefaultLayout extends Vue {
    @Resolve
    layout!: LayoutModule;

    @Resolve
    iri!: IriModule;

    @Resolve
    public path! :Path

    @Resolve
    session!: SessionModule;
    theme = theme;
    styles = styles;

    handleAccountClick() {}

    getUrl(){
        const fullUrl = window.location.pathname;
        const parts = fullUrl.split('/');
        const lastPart = parts[parts.length - 1];
        const lastSecondPart = parts[parts.length - 2];
        return lastPart === "landing" || lastSecondPart === "landing";
    }

    get drawer() {
        return this.layout.drawer;
    }
    set drawer(v) {
        this.layout.setDrawer(v);
    }
    get mini() {
        return this.layout.mini;
    }
    set mini(v) {
        this.layout.setMini(v);
    }
    get iriOpen() {
        return this.iri.open;
    }
    set iriOpen(v) {
        this.iri.toggleIriOpen(v);
    }

    get menu(): object {
        return this.$settings.mainMenu;
    }
    back() {
        this.$router.back();
    }
    get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
